import { deactivateAcquisition } from '../../../../../actions/Utilities/Acquisition';
import { toast } from "components/toastNotification";
import { useMutation } from "react-query";
import { useRecoilState } from "recoil";
import { acquisitionConfigReFetching } from "../atoms/atoms";

export default function useDeactivateAcquisition() {
  const [isReFetching, setIsReFetching] = useRecoilState(
    acquisitionConfigReFetching
  );
  const { mutate } = useMutation(
    (ids: number[]) => deactivateAcquisition(ids),
    {
      onSuccess: (res: any) => {
        if (typeof res == "object") {
          toast.fire(
            "Disabling Acquisition Config failed",
            res.Message,
            "error"
          );
        } else {
          let title = "Disabling Acquisition Config Failed";
          let message = "";
          let type: "success" | "error" | "warning" = "error";

          if (res == "Success") {
            title = "Success";
            message = "Acquisition Config Disabled Successfully";
            type = "success";
          }
          else if (res == "Acquisition Name not found") {
            title = "Acquisition Name not found";
            message = "The selected row/s is/are not found";
            type = "error";
          }
          else if (res.includes("Notification insert Failed")) {
            title = "Success";
            message = `Acquisition Config Disabled Successfully, BUT ${res}`;
            type = "warning";
          }
          else if (["Operation Failed!", "Acquisition Name not found"].includes(res)) {
            message = `Error: ${res}`;
          } 

          toast.fire(title, message, type);
        }
        setIsReFetching(isReFetching ? false : true);
      },
      onError: (error) => {
        toast.fire(
          "Disabling Acquisition Config failed",
          `Error: ${error}`,
          "error"
        );
      },
    }
  );

  return mutate;
}